import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ClientIcon, SkillIcon } from 'app/components/DetailsPages/shared/CommonGround/Icons';
import usePeopleSearchHistory from 'app/components/People/PeopleContent/PeopleSearch/usePeopleSearchHistory';
import { DisciplineIcon, WorldGlobe } from 'app/components/shared/icons';
import useBehavioral, { BEHAVIORALS } from 'hooks/useBehavioral';
import { setPrompt } from 'store/reducers/nlp/nlp-reducer';
import { contextSelector, PEOPLE_CONTEXT } from 'store/reducers/people/people-reducer';

import {
  PeopleStepsOneExamplesItem,
  PeopleStepsOneExamplesItemTitle,
  PeopleStepsOneExamplesList,
  PeopleStepsOneExamplesTitle,
  PeopleStepsOneExamplesWrapper,
} from './styled';

export default function PeopleStepsOneExamples() {
  const dispatch = useDispatch();
  const context = useSelector(contextSelector);
  const { saveSearch } = usePeopleSearchHistory();
  const collectiveDirectoryExamplesClickedBehavioralFunction = useBehavioral(
    BEHAVIORALS.COLLECTIVE_DIRECTORY_QUICK_FILTER_CLICKED
  );
  const teamingExamplesClickedBehavioralFunction = useBehavioral(
    BEHAVIORALS.TEAMING_QUICK_FILTER_CLICKED
  );

  const examplesForCollectiveDirectory = [
    {
      icon: <ClientIcon />,
      title: 'Designers in New York',
    },
    {
      icon: <WorldGlobe />,
      title: 'Travelling to New York. Who can I connect with at kyu?',
    },
    {
      icon: <ClientIcon />,
      title: 'Who is part of the Pulse team?',
    },
    {
      icon: <DisciplineIcon />,
      title: 'Experts in brand and strategy that speak French',
    },
    {
      icon: <ClientIcon />,
      title: 'I want to meet other people in London that’s interested in AI',
    },
  ];

  const examplesForTeaming = [
    {
      icon: <DisciplineIcon />,
      title: 'People skilled in Storytelling',
    },
    {
      icon: <ClientIcon />,
      title: 'Who is part of the Pulse team?',
    },
    {
      icon: <SkillIcon />,
      title: `People that have worked with American Express`,
    },
    {
      icon: <WorldGlobe />,
      title: 'People skilled in digital marketing in New York',
    },
    {
      icon: <ClientIcon />,
      title: 'Who’s skilled in video production and speaks French?',
    },
  ];

  const examples = useMemo(() => {
    if (context === PEOPLE_CONTEXT.COLLECTIVE_DIRECTORY) {
      return examplesForCollectiveDirectory;
    }
    return examplesForTeaming;
  }, [context]);

  const handleExampleClick = (example: string) => {
    if (context === PEOPLE_CONTEXT.COLLECTIVE_DIRECTORY) {
      collectiveDirectoryExamplesClickedBehavioralFunction({ action_details: example });
    } else {
      teamingExamplesClickedBehavioralFunction({ action_details: example });
    }
    saveSearch(example);
    dispatch(setPrompt(example));
  };

  return (
    <PeopleStepsOneExamplesWrapper>
      <PeopleStepsOneExamplesTitle>TRY AN EXAMPLE</PeopleStepsOneExamplesTitle>
      <PeopleStepsOneExamplesList>
        {examples.map((example) => (
          <PeopleStepsOneExamplesItem
            key={example.title}
            onClick={() => handleExampleClick(example.title)}
          >
            {React.cloneElement(example.icon, {
              width: 16,
              height: 16,
              fill: 'var(--color-primary)',
            })}
            <PeopleStepsOneExamplesItemTitle>{example.title}</PeopleStepsOneExamplesItemTitle>
          </PeopleStepsOneExamplesItem>
        ))}
      </PeopleStepsOneExamplesList>
    </PeopleStepsOneExamplesWrapper>
  );
}
